import Bugsnag from "@bugsnag/js";
import "common/bugsnag";

// Can be required with:
//
// import logger from 'common/logger';
//
// and used with:
//
// logger.notify(new Error(...), {...params})
//
// note that the first argument is an Error object, not a string.
// http://www.devthought.com/2011/12/22/a-string-is-not-an-error/

function notify(error, options) {
  if (process.env.NODE_ENV === "test") {
    throw error;
  }

  Bugsnag.notify(error, function addContext(event) {
    event.addMetadata("context", options);
  });
}

// insulating the interface so that error reporting could be changed out
// this exports a singleton
export default {
  notify
};
